module.exports = __webpack_public_path__ + "img/Map.c554b400.png";